import React, { useState, useEffect } from 'react';
import Routes from './Routes';
import Loader from './Layout/Loader';
// import Axios from 'axios';
import instance from './axios';
import { connect, useDispatch,
  //  useSelector
   } from 'react-redux';
import { ServerInfo } from './Actions/serverSetting';
import { withTranslationWrapper } from './HOC';
import i18n from "./i18n";
// import { loadConfig } from './Actions/urlConfig';

const ComposedApp = (props) => {
  // const { data: config, loading:configLoading } = useSelector((state) => state.urlConfig);
  const [whiteLabling, setWhiteLabling] = useState('');
  const [callResponse, setCallResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDown, setIsDown] = useState(false);
  const [mainClass, setMainClass] = useState('');
  const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(loadConfig());
  // }, [dispatch]);
  // const myRef = useRef(null);

  const getImage = async (id, fieldName) => {
    try {
      const response = await instance.get(`/api/media/public/${id}`, {
        responseType: 'arraybuffer',
      });
      const filename = id;
      const parts = filename.split('.');
      const extension = parts[parts.length - 1];

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: `image/${extension}` });
        const reader = new FileReader();
        reader.readAsDataURL(blob);

        reader.onload = () => {
          const base64Image = reader.result;

          setWhiteLabling(prevState => ({
            ...prevState,
            [fieldName]: base64Image
          }));

          if (fieldName === 'favIcon') {
            const domElements = document.getElementById('favicon');
            if (base64Image && domElements) {
              domElements.setAttribute('href', base64Image);
            }
          }
        };
      } else {
        console.error('Failed to fetch image:', response.status, response.statusText);
      }
    } catch (error) {
      console.error('Error in getImage:', error);
    }
  };

  const checkWebsite = () => {
    setLoading(true);
    setCallResponse(false);

    instance({
      url: `/api/accounts/labeling`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      params: {
        hostUrl: window.location.host
      }
    })
      .then(res => {
        getImage(res?.favIcon, 'favIcon');
        getImage(res?.logo, 'logo');
        getImage(res?.logInPageImage, 'logInPageImage');
        setWhiteLabling(res);
        setCallResponse(true);
        setLoading(false);
        dispatch(ServerInfo({ attributes: { ...res } }));
        document.title = res.serviceTitle;
        let domElements = document.getElementById('favicon')
        if (res && res.favIcon && domElements) {
          domElements.setAttribute('href', res.favIcon)
        }
      })
      .catch(error => {
        console.warn("err=====", error);
        setLoading(false);
        setIsDown(false);
        setCallResponse(true);
      });
  };

  // const setCookie = (name, value, exdays) => {
  //   const d = new Date();
  //   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  //   const expires = 'expires=' + d.toUTCString();
  //   document.cookie = name + '= ' + encodeURIComponent(value) + ';' + expires;
  // };

  // const saveIp = async () => {
  //   const response = await Axios.get('https://api.ipify.org/?format=json');
  //   if (response.status === 200 && response.data && response.data.ip) {
  //     setCookie('UIP', response.data.ip, 1);
  //   }
  // };

  const myref = (e) => {
    if (e) {
      setMainClass('scroll-width-' + (e.offsetWidth - e.scrollWidth));
    }
  };

  const setActiveLanguage = (lng) => {
    localStorage.setItem("SelectedLanguage", lng);
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    // if (!configLoading&& config) {
      checkWebsite(); 
    // }
  }, []);

  if (callResponse) {
    return (
      <div className={`fms ${mainClass}`}>
        <Routes {...{ whiteLabling, callResponse, loading, isDown }} {...props} setActiveLanguage={setActiveLanguage} />
        <div
          id='scrollable-div'
          style={{ overflow: 'scroll', opacity: 0, position: 'absolute', left: '-200%', top: '-200%' }}
          ref={myref}
        ></div>
      </div>
    );
  }

  if (loading) {
    return <Loader />;
  } else if (isDown) {
    return <h2 style={{ textAlign: 'center' }}>Oops Something Went Wrong Try Again</h2>;
  } else {
    return null;
  }
};

const App = withTranslationWrapper(connect()(ComposedApp))

export default App;
